module.exports = __webpack_public_path__ + "img/font_monotype-corsiva.df3cf77.svg";